import { authenticate, logout } from "./actions/authActions";

import A from "./analytics";
import AEDCImg from "./assets/img/aedc.png";
import EKEDCImg from "./assets/img/EKEDC.svg";
import axios from "axios";
import ccType from "credit-card-type";
import { setLastTransaction } from "./actions/orderActions";
import { setUserSecurityStatus } from "./actions/utilityActions";
import { snapchatTrack } from "./start";
import { updateUser } from "./actions/userActions";

const CARD_GAPS = [4, 8, 12];

export const isProd = process.env.NODE_ENV === "production";

export const isValidPhone = (n = "") => {
  let number;
  const pattern = /^([0]{1})([7-9]{1})([0|1]{1})([\d]{1})([\d]{7})$/g;

  if (!n || n.length < 5) return false;

  if (typeof n === "number") {
    // numbers never begin with 0, force this to become a string
    number = "0" + n;
  } else if (typeof n === "string") {
    number = n;
  } else {
    return false;
  }

  // remove all whitespace(s) before running test
  number = number.replace(/\s+/g, "");
  return pattern.test(number);
};

export const formatNumber = (num = "") => {
  return String(num).replace(/\D/g, "");
};

export const splitPhoneNumber = (num = "08000000000") => {
  num = String(num).replace(/[^0-9.]+/g, "");
  return `${num.slice(0, 4)}-${num.slice(4, 7)}-${num.slice(7)}`;
};

export const toTitleCase = (str = "") =>
  str
    .split(" ")
    .map((s) => s.slice(0, 1).toUpperCase() + s.slice(1))
    .join(" ");

export const checkFontReady = (font = "") => {
  if (document.fonts.check) {
    return document.fonts.check("1em " + font);
  }
  return true; // Fallback to true
};

export const findHighestZIndex = (t) => {
  for (
    var e = document.getElementsByTagName(t), n = 0, r = 0;
    r < e.length;
    r++
  ) {
    var a = document.defaultView
      .getComputedStyle(e[r], null)
      .getPropertyValue("z-index");
    n < a && "auto" !== a && (n = a);
  }
  return parseInt(n, 10);
};

export const commaNumber = (num = 0) =>
  Number(num).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const toDecimal = (num = 0) => Number(num).toFixed(2);

export const formatAmount = (num, space = false) =>
  `₦${space ? " " : ""}${commaNumber(num)}`;

export const formatAmountDecimal = (num, space = true) =>
  `₦${space ? " " : ""}${toDecimal(num)}`;

export const formatTime = (time) => {
  let date = new Date(time);
  date.setHours(date.getHours() + 1);
  date = date.toUTCString().replace("GMT", "");
  return date;
};
export const formatDateTime = (date) =>
  `${new Date(date).toLocaleDateString("en-GB")} • ${new Date(
    date
  ).toLocaleTimeString("en-GB")}`;

export const formatDate = (date) => new Date(date).toLocaleDateString("en-GB");

export const formatToken = (str) => {
  if (!str) return "";
  str = String(str);
  if (str.indexOf("-") !== -1) return str;
  str = str.toString();
  let totalSplit = Math.floor(str.length / 4);
  let start = 0;
  let end = 4;
  let output = "";
  for (let i = 0; i < totalSplit; i++) {
    output += str.slice(start, end);
    output += i === totalSplit - 1 ? "" : "-";
    start += 4;
    end += 4;
  }
  return output;
};

// Get value from url query parameter
export const getUrlParameter = (key, params) => {
  key = key.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  let regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
  let results = regex.exec(params);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const getQueryParams = () => {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams;
};

export const getQueryParam = (name) => {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get(name);
};

const request = axios.create({
  baseURL: "/client",
  timeout: 150000, // 2 Minutes +
});

export const callApi = (endpoint, data = {}, method = "get") => {
  method = ["get", "post", "put", "delete", "patch"].includes(
    method.toLowerCase()
  )
    ? method.toLowerCase()
    : "post";
  return new Promise((resolve, reject) => {
    const sendData =
      method === "get" || method === "delete" ? { params: data } : { ...data };
    request[method](endpoint, sendData)
      .then((res) => resolve(res.data))
      .catch((err) => {
        if (err.response) {
          // Response from server w/ error
          // check if the error is due to unauthorized access and redirect to login
          if (err.response.status === 403) {
            // window.location.href = "/login";
            logout(false);
            return reject(err.response.data);
          }
          return reject(err.response.data);
        } else {
          // We would normally reject with an Error object here
          // But we use destructuring to display error toaster and the message object is lost in the process
          // Return a direct object with message and title properties
          if (!navigator.onLine) {
            return reject({
              title: "❌ Network Error",
              message: "Please check your internet connection and try again.",
            });
          } else {
            return reject({
              title: "❌ Server Error",
              message: "Error communicating with BuyPower.",
            });
          }
        }
      });
  });
};

// Check if screen size is mobile or desktop
export const isMobile = () => {
  if (window.screen) {
    return window.screen.width < 1020;
  }
  // Default fallback;
  return true;
};

// Check if iPhone
export const isIOS = (() => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
})();

// Get nested object values without errors
export const getNestedObject = (nestedObj, pathArr) =>
  pathArr.reduce(
    (obj, key) => (obj && obj[key] !== "undefined" ? obj[key] : undefined),
    nestedObj
  );

// Feature Detection Functions -> Break Out into Module

export const detectCookies = () => {
  let a;
  const uuid = "njui8765rfv";
  document.cookie = uuid;

  if (document.cookie.indexOf(uuid) >= 0) {
    a = true;
  } else {
    a = false;
  }
  // delete temporoary cookie
  document.cookie = uuid + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  return a;
};

// Load external JS script
export const loadScript = (link, attributes = []) =>
  new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = link;
    script.async = true;
    document.body.appendChild(script);

    //Optional feature to add attributes to script tag EG. <script src = '' one = '' id ='' ></script>
    if (attributes.length) {
      attributes.forEach((attribute) => {
        script.setAttribute(attribute.key, attribute.value);
      });
    }

    // Resolve Promise when script is loaded successfully
    script.onload = resolve;
  });

// Copy to Clipboard
export const copyToClipboard = (text, selector = ".btn", event = null) =>
  new Promise((resolve, reject) => {
    const ClipboardJS = window.ClipboardJS || null;
    if (!ClipboardJS) return reject(false);
    if (!ClipboardJS.isSupported()) return reject(false);

    const clipboard = new ClipboardJS(selector, {
      text: function () {
        return text;
      },
    });

    clipboard.on("success", () => {
      resolve();
      return clipboard.destroy();
    });
    clipboard.on("error", reject);

    // Force Copy. Browser Bug
    event && event.target.click();
  });

export const shareToFacebook = (data, cb = () => null) => {
  if (window.FB) {
    return window.FB.ui({ mobile_iframe: true, ...data }, cb);
  } else {
    return window.location.reload();
  }
};

// Update Page URL
const PAGES = [
  { l: "/auth", t: "Enter Password" },
  { l: "/login", t: "Log In" },
  { l: "/register", t: "Register Account" },
  { l: "/order/create", t: "Create Order" },
  { l: "/order/review", t: "Review Order" },
  { l: "/order/bank", t: "Select Bank" },
  { l: "/order/confirm", t: "Confirm Payment" },
  { l: "/order/complete", t: "Transaction Complete!" },
  { l: "/transactions/details", t: "Transaction Summary" },
  { l: "/transactions", t: "Transactions History" },
  { l: "/contact", t: "Contact Us" },
  { l: "/profile", t: "Profile Details" },
  { l: "/share", t: "Share" },
  { l: "/forgot", t: "Forgot Password" },
  { l: "/", t: "Pay Electricity Bills Online" },
].map((p) => ({ ...p, l: new RegExp(p.l) }));

export const updatePageTitle = (path = "") => {
  try {
    for (let i = 0; i < PAGES.length; i++) {
      const t = PAGES[i];
      if (path.match(t.l)) {
        document.title = "BuyPower | " + t.t;
        break;
      }
    }
  } catch (err) {}
};

export const scrollPage = (px) => {
  setTimeout(
    () =>
      window.scrollTo({
        top: px,
        behavior: "smooth",
      }),
    400
  );
};

export const openInNewTab = (url) => {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  debugger;
  return link.click();
};

// Credit Card Stuff

// Get card type and separator gaps
export const getCardInfo = (num = "") => {
  const info = ccType(num)[0];
  if (info) {
    const isVerve = info.type === "maestro";
    return {
      type: isVerve ? "verve" : info.type,
      gaps: isVerve ? CARD_GAPS.concat(16) : info.gaps || CARD_GAPS,
    };
  } else
    return {
      type: "none",
      gaps: CARD_GAPS,
    };
};

// Format Credit Card
export const formatCard = (num = "", gaps = CARD_GAPS) => {
  let str = "";
  for (let i = 0; i < num.length; i++) {
    if (gaps[0] === i || gaps[1] === i || gaps[2] === i || gaps[3] === i) {
      str += " ";
    }
    str += num[i];
  }
  return str;
};

// Web Push Stuff

export const urlbase64touint8array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  /*eslint no-useless-escape: 0*/
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const swSupported = () => "serviceWorker" in navigator;

// Get Service Worker Registration => Promise
const getSwRegistration = () =>
  new Promise((resolve, reject) => {
    if (swSupported()) {
      return navigator.serviceWorker
        .getRegistration()
        .then((r) => (r ? resolve(r) : reject()))
        .catch(reject);
    } else {
      return reject();
    }
  });

export const subscribeToPush = () =>
  new Promise((resolve, reject) => {
    return !isProd
      ? reject()
      : getSwRegistration()
          .then((registration) => {
            return registration.pushManager
              .subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlbase64touint8array(
                  process.env.REACT_APP_VAPID_PUBLIC_KEY
                ),
              })
              .then((subscription) => {
                console.dir(subscription);
                callApi("/push/subscribe", { subscription }, "post");
                return resolve(subscription);
              });
          })
          .catch(reject);
  });

export const extractQueryParams = (qString, key) => {
  qString = qString.substr(1);

  let qArray = qString.split("&");

  qArray = qArray.filter((q) => q.match(`${key}=.*`));

  if (qArray.length < 1) return undefined;

  return qArray[0].split("=")[1];
};

export const getDiscoIcon = (disco) => {
  switch (disco.toUpperCase()) {
    case "ABUJA":
      return AEDCImg;

    case "EKO":
      return EKEDCImg;

    default:
      return AEDCImg;
  }
};

export const GET_DOMAIN_REDIRECT = (domain) => {
  let redirectUrl;

  switch (domain) {
    case "MTN":
      redirectUrl = "https://mtnapp.page.link/myMTNNGApp";
      break;

    default:
      redirectUrl = window.location.origin;
      break;
  }

  return redirectUrl;
};

export const postLogin = (props, res) => {
  // The order of these actions is very important
  // Authenticate & Redirect MUST fire before updateUser
  // If not, this component will unmount and make redirect impossible
  // See Home.js

  // Analytics: Add user ID to analytics session
  A.setUserId(res.user.id);

  snapchatTrack(res.user.email);

  const isAdmin = [1118326].includes(res.user.id);
  localStorage.setItem("isAdmin", isAdmin);

  props.dispatch(authenticate());
  props.dispatch(setLastTransaction(res.lastTransaction));
  props.history.push("/home");
  props.dispatch(
    updateUser({ ...res.user, meterHistory: res.meterHistory || [] })
  );
  props.dispatch(setUserSecurityStatus(res.user.secure));
};

export const maskPhoneNumber = (phoneNumber) => {
  if (phoneNumber.length < 10) {
    throw new Error("Phone number must be at least 10 characters long.");
  }

  const start = phoneNumber.slice(0, 4);
  const end = phoneNumber.slice(-3);

  const masked = start + "****" + end;

  return masked;
};

export const maskEmail = (email) => {
  const [localPart, domainPart] = email.split("@");

  // Ensure the local part is at least 2 characters long for masking
  if (localPart.length < 2) {
    const asterisks = "*".repeat(localPart.length);
    const maskedEmail = `${asterisks}@${domainPart}`;
    return maskedEmail;
  }

  const visiblePart = localPart.slice(0, 3);
  const asterisks = "*".repeat(localPart.length - 3);
  const maskedEmail = `${visiblePart}${asterisks}@${domainPart}`;

  return maskedEmail;
};



// WEBPACK FOOTER //
// ./src/utils.js